export default __webpack_public_path__ + "static/media/evidstor.48a2e136.png";